/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerFilter('noFilter', function (imgData, cb) {
    cb(imgData);
  });
}(FakeCation));
